var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "landing-cnt row" }, [
    _c("div", { staticClass: "bg-image" }),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 d-xl-none d-lg-flex main-block-xs" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-block-ctn col-xl-6 col-12 d-flex my-auto" },
      [
        _c("div", { staticClass: "text-ctn my-auto" }, [
          !_vm.hideTitle
            ? _c("h1", {
                domProps: { innerHTML: _vm._s(_vm.$t("openlegal.title")) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-cnt" },
            [
              _c(
                "base-button",
                {
                  staticClass: "mt-5",
                  attrs: { white: "", shadow: "" },
                  on: {
                    click: function($event) {
                      return _vm.$helpers.goToSection("contact-form")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("more-info")))]
              ),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "mt-5",
                  attrs: {
                    shadow: "",
                    backgroundColor: _vm.GRAY_COLOUR,
                    textColor: _vm.WHITE_COLOUR,
                    borderColor: _vm.WHITE_COLOUR
                  },
                  on: {
                    click: function($event) {
                      return _vm.$helpers.goToSection("contact-form")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("openlegal.menu.sign-in")))]
              )
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    !_vm.$store.getters["session/isLogged"]
      ? _c(
          "div",
          {
            staticClass: "learn-more",
            on: {
              click: function($event) {
                return _vm.$helpers.goToSection("contact-form")
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("openlegal.more-info")))])]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c42cef6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c42cef6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/openlegal/OpenlegalMainBlock.vue
// module id = 3525
// module chunks = 12